module.exports = __webpack_public_path__ + "static/media/1001681.7319b61d.jpg";